import {MANUAL_CONTROL_ENUM} from '@/constants/enums';
import * as manualControlActionType from '@/constants/manualControlActionType';

/**
 * initial value of StatusManualControl
 */
export const INITIAL_STATUS_MANUAL_CONTROL = {
  // IsManualControlEnable: "false",
  // TotalRunTime: "0",
  // CurrentRunTime: "0",
  // IsLastConcentration: "false",
  IsManualControlEnable: 'false',
  IsManualControlRunning: 'false',
  StartVolume: '0',
  TotalVolume: '0',
  CurrentVolume: '0',
  TotalRunTime: '0',
  CurrentRunTime: '0',
  IsLastConcentration: 'false',
  IsPrimeCompleted: 'false',
};

const initialState = {
  EnableManualControl: {},
  StartManualControl: {},
  StopManualControl: {},
  StatusManualControl: INITIAL_STATUS_MANUAL_CONTROL,
  ManualControlState: MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL,
  SelectedDefaultTime: '0.2',
  VolumeInMl: '0',
  IsHoldToRunActive: false,
  CancelManualControl: {},
  RecoveryOfLiquidManualControl: {},
  RequestPendingManualControl: false,
  TotalRuntimeManualControl: 0,
  IsShowManualControlAvailablePopUp: false,
  IsShowManualControlPopUp: false,
};

export function manualControlStore(state = initialState, action = {}) {
  switch (action.type) {
    case manualControlActionType.ENABLE_MANUAL_CONTROL:
      return {
        ...state,
        EnableManualControl: action.value,
      };

    case manualControlActionType.START_MANUAL_CONTROL:
      return {
        ...state,
        StartManualControl: action.value,
      };

    case manualControlActionType.STOP_MANUAL_CONTROL:
      return {
        ...state,
        StopManualControl: action.value,
      };

    case manualControlActionType.STATUS_MANUAL_CONTROL:
      return {
        ...state,
        StatusManualControl: action.value,
      };

    case manualControlActionType.MANUAL_CONTROL_STATE:
      return {
        ...state,
        ManualControlState: action.value,
      };

    case manualControlActionType.SELECTED_DEFAULT_TIME:
      return {
        ...state,
        SelectedDefaultTime: action.value,
      };

    case manualControlActionType.VOLUME_IN_ML:
      return {
        ...state,
        VolumeInMl: action.value,
      };

    case manualControlActionType.IS_HOLD_TO_RUN_ACTIVE:
      return {
        ...state,
        IsHoldToRunActive: action.value,
      };

    case manualControlActionType.MANUAL_CONTROL_START_VOLUME:
      return {
        ...state,
        StatusManualControl: {
          ...state.StatusManualControl,
          StartVolume: action.value,
        },
      };

    case manualControlActionType.REQUEST_PENDING_MANUAL_CONTROL:
      return {
        ...state,
        RequestPendingManualControl: action.value,
      };

    case manualControlActionType.TOTAL_RUNTIME_MANUAL_CONTROL:
      return {
        ...state,
        TotalRuntimeManualControl: action.value,
      };

    case manualControlActionType.RECOVERY_OF_LIQUID_MANUAL_CONTROL:
      return {
        ...state,
        RecoveryOfLiquidManualControl: action.value,
      };

    case manualControlActionType.CANCEL_MANUAL_CONTROL:
      return {
        ...state,
        CancelManualControl: action.value,
      };

    case manualControlActionType.IS_SHOW_MANUAL_CONTROL_AVAILABLE_POPUP:
      return {
        ...state,
        IsShowManualControlAvailablePopUp: action.value,
      };

    case manualControlActionType.IS_SHOW_MANUAL_CONTROL_POPUP:
      return {
        ...state,
        IsShowManualControlPopUp: action.value,
      };

    default:
      return state;
  }
}

export const postEnableManualControl = (state) => state.manualControlStore.EnableManualControl;
export const postStartManualControl = (state) => state.manualControlStore.StartManualControl;
export const postStopManualControl = (state) => state.manualControlStore.StopManualControl;
export const getStatusManualControl = (state) => state.manualControlStore.StatusManualControl;
export const getManualControlState = (state) => state.manualControlStore.ManualControlState;
export const getTotalRuntimeManualControl = (state) => state.manualControlStore.TotalRuntimeManualControl;
export const getCancelManualControl = (state) => state.manualControlStore.CancelManualControl;
